module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/btn-portuguesse-download.58158345.png";